import merge from "../../logic/reCalc/merge.js"

const recalcData = {
    invoiceLines: {
        description: 'recalc invoice lines',
        operations: [
            {
                id: 'loadProducts',
                type: 'loadEntities',
                sourcePath: 'lines[].itemId',
                targetPath: 'products',
                endpoint: 'product/:id',
                params: {
                    name: 'priceList',
                    fields: ['priceListId', 'campaignId', 'customerGroupId', 'currency'],
                },
            },
            {
                id: 'mergeLines',
                type: 'merge',
                mergeType: 'array',
                sourcePath: 'products',
                targetPath: 'lines',
                valueMap: {
                    'netSalesPrice': 'netSalesPrice',
                }
            }
        ]
    },
    invoicePriceList: {
        description: 'Auto populate the priceListId for a customer',
        operations: [
            {
                id: 'loadPriceList',
                type: 'loadEntities',
                sourcePath: 'campaignCode',
                targetPath: 'priceList',
                endpoint: 'priceList/:id',
                params: {
                    name: 'priceList',
                    fields: ['priceListId', 'campaignId', 'customerGroupId', 'currency'],
                },
            },
            {
                id: 'mergeInvoice',
                type: 'merge',
                mergeType: 'object',
                sourcePath: 'priceList',
                targetPath: 'invoice',
                valueMap: {
                    'priceListId': 'id',
                    'priceListIdName': 'idName',
                    'currency': 'currency'
                }
            }
        ]
    },
    quoteLines: {
        description: 'recalc quote lines',
        operations: [
            {
                id: 'loadProducts',
                type: 'loadEntities',
                sourcePath: 'lines[].itemId',
                targetPath: 'products',
                endpoint: 'product/:id',
                params: {
                    name: 'priceList',
                    fields: ['priceListId', 'campaignId', 'customerGroupId', 'currency'],
                },
            },
            {
                id: 'mergeLines',
                type: 'merge',
                mergeType: 'array',
                sourcePath: 'products',
                targetPath: 'lines',
                valueMap: {
                    'netSalesPrice': 'netSalesPrice',
                }
            }
        ]
    },
    quotePriceList: {
        description: 'Auto populate the priceListId for a quote customer',
        operations: [
            {
                id: 'loadPriceList',
                type: 'loadEntities',
                sourcePath: 'campaignCode',
                targetPath: 'priceList',
                endpoint: 'priceList/:id',
                params: {
                    name: 'priceList',
                    fields: ['priceListId', 'campaignId', 'customerGroupId', 'currency'],
                },
            },
            {
                id: 'mergeQuote',
                type: 'merge',
                mergeType: 'object',
                sourcePath: 'priceList',
                targetPath: 'quote',
                valueMap: {
                    'priceListId': 'id',
                    'priceListIdName': 'idName',
                    'currency': 'currency'
                }
            }
        ]
    },
    contactPriceList: {
        description: 'Auto populate the priceListId for a customer',
        operations: [
            {
                id: 'loadPriceList',
                type: 'loadEntities',
                sourcePath: 'customerGroup',
                targetPath: 'priceList',
                endpoint: 'priceList/:id',
                params: {
                    name: 'priceList',
                    fields: ['priceListId', 'campaignId', 'customerGroupId', 'currency'],
                },
            },
            {
                id: 'mergeContact',
                type: 'merge',
                mergeType: 'object',
                sourcePath: 'priceList',
                targetPath: 'contact',
                valueMap: {
                    'priceListId': 'id',
                    'priceListIdName': 'idName',
                    'currency': 'currency'
                }
            }
        ]
    }
}

export default recalcData